export default __webpack_public_path__ + "static/media/outsourcing-page.aad42919.gif";